import { resetApiCallState } from "../Utils";
import {
  ServiceRequestActionTypes,
  ServiceRequestStateTypes,
} from "./ServiceRequest.type";

const initialState: ServiceRequestStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ServiceRequestReducer = (
  state = initialState,
  action: { type: string; payload: any }
): ServiceRequestStateTypes => {
  const { type, payload } = action;

  switch (type) {
    case ServiceRequestActionTypes.FETCH_ALL_SERVICE_REQUEST:
      return {
        ...state,
        fetchAll: { ...state.fetchAll, isPending: true, isSuccessful: false },
      };
    case ServiceRequestActionTypes.FETCH_ALL_SERVICE_REQUEST_SUCCESS:
      return {
        ...state,
        fetchAll: { payload: payload, isPending: false, isSuccessful: true, error: null },
      };
    case ServiceRequestActionTypes.FETCH_ALL_SERVICE_REQUEST_FAILURE:
      return {
        ...state,
        fetchAll: { ...state.fetchAll, isPending: false, isSuccessful: false, error: payload },
      };
    case ServiceRequestActionTypes.FETCH_ALL_SERVICE_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };

    case ServiceRequestActionTypes.FETCH_ONE_SERVICE_REQUEST:
      return {
        ...state,
        fetchOne: { ...state.fetchOne, isPending: true, isSuccessful: false },
      };
    case ServiceRequestActionTypes.FETCH_ONE_SERVICE_REQUEST_SUCCESS:
      return {
        ...state,
        fetchOne: { payload: payload, isPending: false, isSuccessful: true, error: null },
      };
    case ServiceRequestActionTypes.FETCH_ONE_SERVICE_REQUEST_FAILURE:
      return {
        ...state,
        fetchOne: { ...state.fetchOne, isPending: false, isSuccessful: false, error: payload },
      };
    case ServiceRequestActionTypes.FETCH_ONE_SERVICE_REQUEST_RESET:
      return {
        ...state,
        fetchOne: resetApiCallState({}),
      };

    default:
      return state;
  }
};

export default ServiceRequestReducer;
